import { createAsyncThunk, createSlice, ActionReducerMapBuilder } from '@reduxjs/toolkit';
import axios from 'axios';
import { IToken } from '../../../../interfaces';
import store, { useAppDispatch } from '../../../app/Store';

const VENDOR_MC_URL = `${process.env.REACT_APP_API_PIM_URL}/vendor`;

interface IState {
  data: IToken[];
  loading: boolean;
  done: boolean;
  showError: boolean;
  error: any;
  deleteLoading: boolean;
  createLoading: boolean;
}

const initialState: IState = {
  data: [] as IToken[],
  loading: false,
  done: false,
  error: null,
  showError: false,
  deleteLoading: false,
  createLoading: false,
};

export const getTokenList = createAsyncThunk('token-info/list', async () => {
  const {
    auth: { user },
  } = store.getState();
  const res = await axios.get<IToken[]>(`${VENDOR_MC_URL}/${user?.vendor?.id}/token`);
  return res.data;
});

export const deleteApiKey = createAsyncThunk('token-info/delete', async (apiKey: string) => {
  const {
    auth: { user },
  } = store.getState();
  const res = await axios.get<IToken[]>(`${VENDOR_MC_URL}/${user?.vendor?.id}/token/delete/${apiKey}`);
  return res.data;
});

export const createApiKey = createAsyncThunk('token-info/create', async () => {
  const {
    auth: { user },
  } = store.getState();

  await axios.get<IToken[]>(`${VENDOR_MC_URL}/${user?.vendor?.id}/token/create`);
  const tokenInfo = await store.dispatch(getTokenList()).unwrap();
  console.log('tokenInfo', tokenInfo);
  return tokenInfo;
});

const tokenSlice = createSlice({
  name: 'token-info',
  initialState,
  reducers: {
    setError: (state, action) => {
      state.showError = action.payload;
    },
  },
  extraReducers: (builder: ActionReducerMapBuilder<IState>) => {
    builder.addCase(getTokenList.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getTokenList.fulfilled, (state, action) => {
      state.data = action.payload;
      state.loading = false;
      state.done = true;
    });
    builder.addCase(getTokenList.rejected, (state, action) => {
      state.loading = false;
      state.showError = true;
      state.error = 'Hata! Veri eklenemedi.';
    });
    //
    builder.addCase(createApiKey.pending, (state, action) => {
      state.createLoading = true;
    });
    builder.addCase(createApiKey.fulfilled, (state, action) => {
      state.data = action.payload;
      state.createLoading = false;
    });
    builder.addCase(createApiKey.rejected, (state, action) => {
      state.createLoading = false;
      state.showError = true;
      state.error = 'Hata! Token bilgisi oluşturulamadı.';
    });
    //
    builder.addCase(deleteApiKey.pending, (state, action) => {
      state.deleteLoading = true;
    });
    builder.addCase(deleteApiKey.fulfilled, (state, action: any) => {
      const cpyKeys = [...state.data];
      state.data = cpyKeys.filter((key) => key.apiKey !== action.payload?.apiKey);
      state.deleteLoading = false;
      state.done = true;
    });
    builder.addCase(deleteApiKey.rejected, (state, action) => {
      state.deleteLoading = false;
      state.showError = true;
      state.error = 'Hata! Token bilgisi silinemedi.';
    });
    //
  },
});
export const { setError } = tokenSlice.actions;
export default tokenSlice.reducer;
